export default __webpack_public_path__ + "static/media/graceofnature.1825afe3.png";